import { OpportunitiesModule } from '../core/opportunities.module';

OpportunitiesModule.factory('customScriptService', CustomScriptService);

/* @ngInject */
function CustomScriptService(coreApi) {
    var service = {
        getCustomScriptsByDealerId: getCustomScriptsByDealerId,
        saveCustomScript: saveCustomScript,
    };

    return service;

    function getCustomScriptsByDealerId(dealerId) {
        assert(dealerId, 'dealerId must be provided');
        return coreApi.api.CustomScript.GetCustomScriptsByDealerId.GET({ dealerId })
            .then(response => (response.data || []).map(mapCustomScript));
    }

    function saveCustomScript(customScript) {
        assert(customScript, 'customScript must be provided');
        return coreApi.api.CustomScript.SaveCustomScript.POST(customScript)
            .then(response => response.status === 204);
    }

    function mapCustomScript(script) {
        return {
            id: script.id ?? script.customScriptID ?? script.customScriptId,
            dealerID: script.dealerID ?? script.dealerId,
            scriptTypeID: script.scriptTypeID ?? script.scriptTypeId,
            culture: script.culture,
            version: script.version,
            createDate: script.createDate,
            createdBy: script.createdBy,
            createdByFullName: script.createdByFullName ?? script.createdByName ?? script.createdByUserName ?? script.createdBy,
            scriptBody: script.scriptBody,
        };
    }

    function assert(condition, message) {
        if (!condition) {
            throw new Error(message);
        }
    }
}
